import type { ISerialize } from '@/objects/ISerialize';

export class ProductionDisplayDataItem implements ISerialize {
    public Additionals: string | null;

    public Behind: string | null;

    public Bib: number | null;

    public CategoryId: number;

    public CategoryName: string | null;

    public ClubTeam: string | null;

    public ElapsedTime: string | null;

    public EventId: number;

    public FromSignalR: boolean;

    public Name: string | null;

    public RaceContestantId: number;

    public RaceId: number;

    public Rank: number;

    public Round: number;

    public StartingTime: string | null;

    public StationRoleId: number;

    public StationRoleName: string | null;

    public Time: string | null;

    public TimeStatus: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        Additionals?: string | null;
        Behind?: string | null;
        Bib?: number | null;
        CategoryId?: number;
        CategoryName?: string | null;
        ClubTeam?: string | null;
        ElapsedTime?: string | null;
        EventId?: number;
        FromSignalR?: boolean;
        Name?: string | null;
        RaceContestantId?: number;
        RaceId?: number;
        Rank?: number;
        Round?: number;
        StartingTime?: string | null;
        StationRoleId?: number;
        StationRoleName?: string | null;
        Time?: string | null;
        TimeStatus?: string | null;
    }) {
        this.Additionals = values.Additionals ?? '';

        this.Behind = values.Behind ?? '';

        this.Bib = values.Bib ?? null;

        this.CategoryId = values.CategoryId ?? 0;

        this.CategoryName = values.CategoryName ?? '';

        this.ClubTeam = values.ClubTeam ?? '';

        this.ElapsedTime = values.ElapsedTime ?? '';

        this.EventId = values.EventId ?? 0;

        this.FromSignalR = values.FromSignalR ?? false;

        this.Name = values.Name ?? '';

        this.RaceContestantId = values.RaceContestantId ?? 0;

        this.RaceId = values.RaceId ?? 0;

        this.Rank = values.Rank ?? 0;

        this.Round = values.Round ?? 0;

        this.StartingTime = values.StartingTime ?? null;

        this.StationRoleId = values.StationRoleId ?? 0;

        this.StationRoleName = values.StationRoleName ?? '';

        this.Time = values.Time ?? '';

        this.TimeStatus = values.TimeStatus ?? '';
    }

    public serialize(): string {
        return (
            '{' +
            `"Additionals": ${JSON.stringify(this.Additionals)}` +
            ',' +
            `"Behind": ${JSON.stringify(this.Behind)}` +
            ',' +
            `"Bib": ${JSON.stringify(this.Bib)}` +
            ',' +
            `"CategoryId": ${JSON.stringify(this.CategoryId)}` +
            ',' +
            `"CategoryName": ${JSON.stringify(this.CategoryName)}` +
            ',' +
            `"ClubTeam": ${JSON.stringify(this.ClubTeam)}` +
            ',' +
            `"ElapsedTime": ${JSON.stringify(this.ElapsedTime)}` +
            ',' +
            `"EventId": ${JSON.stringify(this.EventId)}` +
            ',' +
            `"FromSignalR": ${JSON.stringify(this.FromSignalR)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"RaceContestantId": ${JSON.stringify(this.RaceContestantId)}` +
            ',' +
            `"RaceId": ${JSON.stringify(this.RaceId)}` +
            ',' +
            `"Rank": ${JSON.stringify(this.Rank)}` +
            ',' +
            `"Round": ${JSON.stringify(this.Round)}` +
            ',' +
            `"StartingTime": ${JSON.stringify(this.StartingTime)}` +
            ',' +
            `"StationRoleId": ${JSON.stringify(this.StationRoleId)}` +
            ',' +
            `"StationRoleName": ${JSON.stringify(this.StationRoleName)}` +
            ',' +
            `"Time": ${JSON.stringify(this.Time)}` +
            ',' +
            `"TimeStatus": ${JSON.stringify(this.TimeStatus)}` +
            '}'
        );
    }

    /**
     * Creates an instance of ProductionDisplayDataItem from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        Additionals?: string | null;
        Behind?: string | null;
        Bib?: number | null;
        CategoryId?: number;
        CategoryName?: string | null;
        ClubTeam?: string | null;
        ElapsedTime?: string | null;
        EventId?: number;
        FromSignalR?: boolean;
        Name?: string | null;
        RaceContestantId?: number;
        RaceId?: number;
        Rank?: number;
        Round?: number;
        StartingTime?: string | null;
        StationRoleId?: number;
        StationRoleName?: string | null;
        Time?: string | null;
        TimeStatus?: string | null;
    }): ProductionDisplayDataItem {
        return new ProductionDisplayDataItem(values);
    }

    public static _FromServerJson(json: any): ProductionDisplayDataItem {
        return new ProductionDisplayDataItem({
            Additionals: json.Additionals ?? '',
            Behind: json.Behind ?? '',
            Bib: json.Bib ?? null,
            CategoryId: json.CategoryId,
            CategoryName: json.CategoryName ?? '',
            ClubTeam: json.ClubTeam ?? '',
            ElapsedTime: json.ElapsedTime ?? '',
            EventId: json.EventId,
            FromSignalR: json.FromSignalR,
            Name: json.Name ?? '',
            RaceContestantId: json.RaceContestantId,
            RaceId: json.RaceId,
            Rank: json.Rank,
            Round: json.Round,
            StartingTime: json.StartingTime ?? '',
            StationRoleId: json.StationRoleId,
            StationRoleName: json.StationRoleName ?? '',
            Time: json.Time ?? '',
            TimeStatus: json.TimeStatus ?? '',
        });
    }

    /**
     * Creates an instance of ProductionDisplayDataItem from another instance of ProductionDisplayDataItem.
     * @param other The ProductionDisplayDataItem you want to clone
     * @returns A cloned ProductionDisplayDataItem
     */
    public static FromOther(other: ProductionDisplayDataItem): ProductionDisplayDataItem {
        return ProductionDisplayDataItem._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ProductionDisplayDataItem.FromOther(this);
    }

    static NAME_OF_CLASS = 'ProductionDisplayDataItem';
}
